import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { closeButtonDriverFactory } from '../CloseButton/CloseButton.uni.driver';

const toastDismissButtonDriverFactory = (base: UniDriver) => {
  const { exists, element, click, getAriaLabel, isButtonDisabled } =
    closeButtonDriverFactory(base);

  return {
    exists,
    element,
    click,
    getAriaLabel,
    isDisabled: isButtonDisabled,
  };
};

export const toastDriverFactory = (base: UniDriver) => {
  const getDismissButtonDriver = async () =>
    toastDismissButtonDriverFactory(
      await base.$('[data-hook="toast-dismiss-button"]'),
    );

  return {
    ...baseUniDriverFactory(base),
    getRole: async () => base.attr('role'),
    getAriaLive: async () => base.attr('aria-live'),
    isVisible: async () => (await base.attr('aria-hidden')) === 'false',
    isDismissible: async () => (await getDismissButtonDriver()).exists(),
    getDismissButton: getDismissButtonDriver,
  };
};

export type ToastUniDriver = ReturnType<typeof toastDriverFactory>;
